import { unwrap } from '@exodus/jotai/utils';
import { atom } from '../core/atom.js';
function safeGet(store, atom) {
    try {
        return store.get(atom);
    }
    catch {
        return null;
    }
}
export function atomWithPolling(read) {
    const refreshAtom = atom(0);
    const baseAtom = atom((get, options) => {
        get(refreshAtom);
        return read(get, options);
    });
    let scheduledAt = null;
    let currentInterval = null;
    let store;
    baseAtom.unstable_onInit = (s) => {
        store = s;
        scheduledAt = null;
        currentInterval = null;
    };
    const valueAtom = atom(async (get) => {
        const { value } = await get(baseAtom);
        return value;
    }, () => { });
    const unwrappedBaseAtom = unwrap(baseAtom);
    valueAtom.onMount = () => {
        let timeoutId = null;
        const refresh = () => store.set(refreshAtom, (count) => count + 1);
        const clearTimeoutId = () => (timeoutId ? clearTimeout(timeoutId) : null);
        const unsubscribe = store.sub(unwrappedBaseAtom, () => {
            const value = safeGet(store, unwrappedBaseAtom);
            if (!value || !('interval' in value))
                return clearTimeoutId();
            scheduledAt = Date.now();
            currentInterval = value.interval;
            timeoutId = setTimeout(refresh, value.interval);
        });
        const remainingInterval = scheduledAt
            ? Math.max(scheduledAt + currentInterval - Date.now(), 0)
            : null;
        if (remainingInterval !== null) {
            timeoutId = setTimeout(refresh, remainingInterval);
        }
        return () => {
            unsubscribe();
            clearTimeoutId();
        };
    };
    return valueAtom;
}
export default atomWithPolling;
